import { Pipe, PipeTransform } from '@angular/core';
import { ReportRecord, ReportRecordPipeOptions } from '../../models/report.model';

@Pipe({
  name: 'condensedRecordData',
  standalone: false,
})
export class CondensedRecordDataPipe implements PipeTransform {
  transform(reportData: ReportRecord, options: ReportRecordPipeOptions): ReportRecord {
    const recordData = reportData.data[options.recordIndex];
    reportData = { ...reportData, data: [recordData] };
    return reportData;
  }
}
